export const RIModuleTypes = {
  NS: 'Name Screening',
  TS: 'Transaction Screening',
  PS: 'Prospect Name Screening',
  RS: 'Risk Scoring'
};

export const RIModuleSourceIDs = {
  NS: 7,
  TS: 9,
  PS: 16,
  RS: 17
};
